export class PriceListModel {
  priceListId: number = 0;
  branchId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  name: string = '';
  rateDiscount: number = 0;
  observation: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
